<div class="user-details">
  <div class="user-header">
    <button class="btn btn-rg btn-light back-btn" (click)="goBack()">
      <ng-icon name="iconoirNavArrowLeft" size="20"></ng-icon>
      {{ dictionaryService.get('Back') }}
    </button>

    <div class="user-info">
      <div class="user-avatar">{{ userInitial }}</div>
      <h2 class="user-name">{{ userName() }}</h2>
    </div>
  </div>

  <app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
    <app-supervisor-activities-calendar-tab [userId]="userId()" />
    <app-supervisor-single-visit-tab [userId]="userId()" />
    <app-supervisor-double-visits-tab [userId]="userId()" />
    <app-supervisor-nfa-tab [userId]="userId()" />
  </app-tabs>
</div>
